<template>
  <Details
    :breaditem="breaditem"
    detailTitle="其他新闻资讯"
    :DetailsList="DetailsList"
    :ListClick="ListClick"
    :active="active"
    :listType="listType"
  >
    <div class="new-details">
      <h2 class="new-details-title">{{ detailsList.title }}</h2>
      <span class="new-details-span">
        {{
          existData(detailsList, "source", "")
            ? existData(detailsList, "source", "") + " | "
            : ""
        }}{{ getDate(detailsList.createTime) }} {{ loginType ? " | " : "" }}
        <a
          class="collect-icon"
          v-if="!collect && loginType"
          @click.stop="collectProject"
        >
          <img src="@/assets/img/icon/collect.png" />收藏
        </a>
        <a
          class="collect-icon collect-true"
          v-else-if="collect && loginType"
          @click.stop="collectProject"
        >
          <img src="@/assets/img/icon/collectTrue.png" />收藏
        </a>
      </span>
      <img :src="getImgUrl(detailsList.photoUrl)" class="detail-img-first" />
      <p v-html="detailsList.content"></p>
    </div>
    <div id="comment" class="news-comments" ref="comment">
      <Title title="用户评论" :left="true" :all="true"></Title>
      <a-textarea
        placeholder="说点什么吧"
        :rows="8"
        allowClear
        v-model="text"
        :maxLength="180"
      />
      <div class="button">
        <b-button variant="primary" @click="report(null)">评论</b-button>
      </div>
      <hr />
      <div class="comments-list">
        <h5>
          全部评论
          <span>{{ ReportNum }}</span>
        </h5>
        <ul>
          <li v-for="(item, index) in reportData" :key="index">
            <div class="comment-list-own">
              <img
                v-if="item.user && item.user.avatar"
                :src="getImgUrl(item.user.avatar)"
              />
              <a-avatar v-else :size="46" icon="user" />
              <div class="comments-list-title">
                <h6>
                  {{ item.user ? item.user.nickname : "" }}
                  <span>{{
                    $moment(item.createTime).format("YYYY-MM-DD hh:mm:ss")
                  }}</span>
                </h6>
                <p>{{ item.comment }}</p>
              </div>
              <div class="comments-icon">
                <a @click="showReport(item, index)" class="report-icon">
                  <img src="@/assets/img/new/news/report.png" alt />
                </a>
              </div>
            </div>

            <div
              class="comment-report-connent"
              v-if="item.recomments && item.recomments.length > 0"
            >
              <div class="block"></div>
              <div class="comment-report">
                <div
                  class="report"
                  v-for="(items, indexs) in item.recomments"
                  :key="indexs"
                >
                  <div class="report-other">
                    <h6>{{ items.user ? items.user.nickname : "" }}</h6>
                    <p>{{ items.comment }}</p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="comment-report-textarea" v-if="reportShow == index">
              <div class="comment-report-textarea-flex">
                <div class="block"></div>
                <a-input
                  placeholder="说点什么吧"
                  :rows="8"
                  allowClear
                  v-model="textReport"
                  :maxLength="180"
                />
              </div>
              <div class="button">
                <b-button variant="primary" @click="reply">回复</b-button>
              </div>
            </div>
            <hr />
          </li>
        </ul>
        <div class="comments-footer">
          <div class="more">
            <a v-if="moreReport" @click="getReport('all')">点击展开更多评论</a>
            <p v-else>没有更多的评论了</p>
          </div>
          <div class="icon">
            <a style="display:flex;align-items:center" @click="goReport()">
              <a-icon type="edit" />写评论
            </a>
          </div>
        </div>
      </div>
    </div>
  </Details>
</template>
<script>
import Details from "@/components/details.vue";
import publicChange from "@/assets/js/index.js";
import Title from "@/components/Title.vue";
import Api from "@/apis";
export default {
  name: "new-details",
  data() {
    return {
      collectArr: [],
      collect: false,
      routerId: this.$route.query.id || 0,
      moreReport: false,
      type: "post",
      reportPid: null,
      target: null,
      loginType: false,
      text: "",
      textReport: "",
      reportShow: null,
      listType: 1,
      ReportNum: 0,
      newDetailsData: [],
      detailsList: {},
      breaditem: [
        {
          text: "新闻资讯",
          to: "/new"
        },
        {
          text: "新闻详情"
        }
      ],
      DetailsList: [],
      active: 0,
      reportData: []
    };
  },
  mounted() {
    this.getNewData();
    if (this.login()) {
      this.getCollectProject(this.type);
      this.loginType = true;
    } else {
      this.loginType = false;
    }
    this.getReport();
  },
  components: {
    Details,
    Title
  },
  methods: {
    //获取是否有收藏
    async getCollectProject() {
      try {
        let query = {
          type: "post",
          current: 1
        };
        const data = await Api.Collection.getCollection(query);
        if (data.data && data.data.length > 0) {
          let arr = [];
          data.data.map(item => {
            arr.push(item.post.id);
            if (arr.indexOf(parseInt(this.routerId)) > -1) {
              this.collect = true;
            } else {
              this.collect = false;
            }
          });
          this.collectArr = arr;
        }
      } catch (e) {
        console.log(e, "获取收藏失败");
      }
    },
    async collectProject() {
      if (!this.collect) {
        try {
          let query = {
            objectId: this.routerId,
            objectType: "post"
          };
          const data = await Api.Collection.createCollection(query);
          if (data) {
            this.$message.success("收藏成功");
            this.collect = true;
            this.getCollectProject();
          } else {
            this.$message.error("收藏失败");
          }
        } catch (e) {
          console.log(e, "收藏失败");
        }
      } else {
        try {
          let query = {
            objectId: this.routerId,
            objectType: "post",
            id: this.routerId
          };
          const data = await Api.Collection.deleteCollection(query);
          if (data) {
            this.$message.success("取消收藏成功");
            this.collect = false;
            this.getCollectProject();
          } else {
            this.$message.error("取消收藏失败");
          }
        } catch (e) {
          console.log("取消收藏失败");
        }
      }
    },
    //评论
    async report(pid) {
      if (this.login()) {
        if (pid) {
          const text = this.textReport;
          if (text == "") {
            this.$message.error("回复内容不能为空");
          } else {
            let query = {
              objectType: "post",
              objectId: this.routerId,
              comment: text,
              pid: pid
            };
            const data = await Api.Comment.createComment(query);
            if (data) {
              this.$message.success("回复成功,请耐心等待审核");
              this.textReport = "";
            } else {
              this.$message.error("回复失败");
            }
          }
        } else {
          const text = this.text;
          if (text == "") {
            this.$message.error("评论内容不能为空");
          } else {
            let query = {
              objectType: "post",
              objectId: this.routerId,
              comment: text
            };
            const data = await Api.Comment.createComment(query);
            if (data) {
              this.$message.success("评论成功,请耐心等待审核");
              this.text = "";
            } else {
              this.$message.error("评论失败");
            }
          }
        }
        this.getReport(this.routerId);
      } else {
        this.$message.warning("请先登录后评论");
        this.$router.push({
          path: "/login",
          query: { redirect: location.href }
        });
      }
    },
    async getReport(id) {
      if (id && id !== "all") {
        try {
          const data = await Api.Comment.getComment("post", id);
          this.ReportNum = data.data.length || 0;
          if (data.data && data.data.length > 0) {
            let reportArr = [];
            data.data.map(item => {
              if (item.pid == 0) {
                reportArr.push(item);
              }
            });
            if (reportArr && reportArr.length > 5) {
              this.moreReport = true;
            } else {
              this.moreReport = false;
            }
            this.ReportNum = reportArr.length || 0;
            this.reportData = reportArr.slice(0, 5);
          } else {
            this.reportData = [];
          }
        } catch (e) {
          console.log(e, "获取评论出错");
        }
      } else if (id && id == "all") {
        try {
          const data = await Api.Comment.getComment("post", this.routerId);
          console.log(this.routerId)
          if (data.data && data.data.length > 0) {
            let reportArr = [];
            data.data.map(item => {
              if (item.pid == 0) {
                reportArr.push(item);
              }
            });
            this.ReportNum = reportArr.length || 0;
            this.reportData = reportArr;
            this.moreReport = false;
          } else {
            this.reportData = [];
          }
        } catch (e) {
          console.log(e, "获取评论出错");
        }
      } else {
        try {
          const data = await Api.Comment.getComment("post", this.routerId);
          this.ReportNum = data.data.length || 0;
          if (data.data && data.data.length > 0) {
            let reportArr = [];
            data.data.map(item => {
              if (item.pid == 0) {
                reportArr.push(item);
              }
            });
            this.ReportNum = reportArr.length || 0;
            this.reportData = reportArr.slice(0, 5);
            if (reportArr && reportArr.length > 5) {
              this.moreReport = true;
            } else {
              this.moreReport = false;
            }
          } else {
            this.reportData = [];
          }
        } catch (e) {
          console.log(e, "获取评论出错");
        }
      }
    },
    //回复
    reply() {
      this.report(this.reportPid);
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    getDate(time) {
      return publicChange.getDate(time);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    login() {
      return publicChange.userLogin();
    },
    ListClick(index) {
      this.active = index;
      this.routerId = index;
      this.getNewData(index);
      this.getReport(index);
      this.getCollectProject(this.type);
      if (this.collectArr.indexOf(this.routerId) > -1) {
        this.collect = true;
      } else {
        this.collect = false;
      }
      (this.text = ""), (this.textReport = "");
      this.reportShow = null;
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    async getNewData(id) {
      if (id) {
        try {
          const query = {
            pageSize: 10,
            current: 1
          };
          this.active = parseInt(id);
          const data = await Api.CMS.getCmsDeatil(id);
          const datas = await Api.CMS.getCms("channel", query);
          let list = [];
          for (let i of datas.data) {
            list.push({
              id: i.id,
              text: i.title || ""
            });
          }
          this.DetailsList = list;
          this.newDetailsData = datas;
          this.detailsList = data;
        } catch (e) {
          this.$message.error(e);
        }
      } else {
        try {
          const query = {
            pageSize: 10,
            current: 1
          };
          const router = this.$route.query.id;
          this.active = parseInt(router);
          const data = await Api.CMS.getCmsDeatil(router);
          const datas = await Api.CMS.getCms("channel", query);
          let list = [];
          for (let i of datas.data) {
            list.push({
              id: i.id,
              img: i.avatar,
              text: i.title || ""
            });
          }
          this.DetailsList = list;
          this.newDetailsData = datas;
          this.detailsList = data;
        } catch (e) {
          this.$message.error(e);
        }
      }
    },
    //显示回复框
    showReport(item, index) {
      this.textReport = "";
      this.reportPid = item.id;
      this.reportShow = index;
    },
    goReport() {
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let TOP = this.$refs.comment.offsetTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= TOP) {
          clearInterval(timeTop);
        }
      }, 10);
    }
  }
};
</script>
<style lang="scss" scoped></style>
